<template>
  <SlideShow
    :interval="interval"
    :submissions="submissions"
    :students="students"
    :submissionStatus="submissionStatus"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import SlideShow from '../components/SlideShow.vue';

export default {
  components: { SlideShow },
  computed: {
    ...mapGetters([
      'slides', 'interval',
      'submissions', 'students', 'submissionStatus'
    ])
  }
};
</script>
